interface SourceSet {
  media: string;
  srcSet: string;
}

interface GetSourceSetInterface {
  breakpoint: number;
  url?: string;
  imageWidth: number;
}

/**
 * @deprecated DO NOT USE OR THE POLICE WILL COME FOR YOU! Use `getSourceSet` from `@dotcom/ui` instead.
 */
export const getSourceSet = ({
  breakpoint,
  url,
  imageWidth,
}: GetSourceSetInterface): SourceSet => {
  return {
    media: `(min-width: ${breakpoint}px)`,
    srcSet: `${url ?? ""}?q=60&dpr=1&w=${imageWidth} 1x, ${
      url ?? ""
    }?q=35&dpr=2&w=${imageWidth} 2x`,
  };
};

interface GetImageSourcesParameters {
  mobile: {
    url?: string;
    alt?: string;
    imageWidth: number;
    breakpoint: number;
  };
  tablet: {
    url?: string;
    alt?: string;
    imageWidth: number;
    breakpoint: number;
  };
  desktop: {
    url?: string;
    alt?: string;
    imageWidth: number;
    breakpoint: number;
  };
  desktopWide: {
    url?: string;
    alt?: string;
    imageWidth: number;
    breakpoint: number;
  };
}

export interface GetImageSourcesResponse {
  source: string;
  alt?: string;
  sources: SourceSet[];
}

/**
 * @deprecated DO NOT USE! Use `parseDatoImageSet` from `@dotcom/dato` on the server
 *     and the `Image` component from `@dotcom/ui` on the client instead. Please see `docs/images.md` for a full guide.
 */
const getImageSources = ({
  mobile,
  tablet,
  desktop,
  desktopWide,
}: GetImageSourcesParameters): GetImageSourcesResponse => {
  return {
    source: `${desktop.url ?? ""}?q=60&dpr=1&w=${desktop.imageWidth}`,
    alt: desktop.alt ?? tablet.alt ?? mobile.alt,
    sources: [
      getSourceSet({
        breakpoint: desktopWide.breakpoint,
        url: desktopWide.url,
        imageWidth: desktopWide.imageWidth,
      }),
      getSourceSet({
        breakpoint: desktop.breakpoint,
        url: desktop.url,
        imageWidth: desktop.imageWidth,
      }),
      getSourceSet({
        breakpoint: tablet.breakpoint,
        url: tablet.url,
        imageWidth: tablet.imageWidth,
      }),
      getSourceSet({
        breakpoint: mobile.breakpoint,
        url: mobile.url,
        imageWidth: mobile.imageWidth,
      }),
    ],
  };
};

export default getImageSources;
